export enum ResolutionEnum {
  DAY = 'D',
  MONTH = 'M',
}

export const ResolutionEnumDisplay = {
  [ResolutionEnum.DAY]: '日',
  [ResolutionEnum.MONTH]: '月',
};

export enum ElecType {
  PV = 0,
  WIND_POWER = 1,
  LOAD = 2,
  ELEC_SUPPLY = 3,
}

export const ElecTypeDisplay = {
  [ElecType.PV]: '光伏发电量',
  [ElecType.WIND_POWER]: '风力发电量',
  [ElecType.LOAD]: '负荷用电',
  [ElecType.ELEC_SUPPLY]: '市电下网电量',
};
